import i18n from '@/utils/i18n';
import React from 'react';
import {
  DropdownMenu,
  Icons,
  Typography,
  XStack,
  YStack,
} from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const DROPDOWN_WIDTH = 280;
const OPTION_ICON_SIZE = 16;

interface CreateOrderGuideOption {
  description: string;
  Icon: React.ComponentType<{ color?: string; size?: number }>;
  label: string;
  onPress: () => void;
}

interface CreateOrderGuideDropdownContentProps {
  close: () => void;
  onSelectOnlineMenu: () => void;
  onSelectUploadPhotoOrFile: () => void;
  showOnlineMenuOption: boolean;
  showUploadPhotoOrFileOption: boolean;
}

export const CreateOrderGuideDropdownContent: React.FC<
  CreateOrderGuideDropdownContentProps
> = ({
  close,
  onSelectOnlineMenu,
  onSelectUploadPhotoOrFile,
  showOnlineMenuOption,
  showUploadPhotoOrFileOption,
}) => {
  const theme = useTheme();
  const optionTitleLineHeight = theme.sk.typography.paragraph.md.lineHeight;

  const options: CreateOrderGuideOption[] = [
    ...(showOnlineMenuOption
      ? [
          {
            description: i18n.t(
              'sales_portal.create_order_guide.online_menu_description',
            ),
            Icon: Icons.FileText,
            label: i18n.t('sales_portal.create_order_guide.online_menu'),
            onPress: onSelectOnlineMenu,
          },
        ]
      : []),
    ...(showUploadPhotoOrFileOption
      ? [
          {
            description: i18n.t(
              'sales_portal.create_order_guide.upload_photo_or_file_description',
            ),
            Icon: Icons.Camera,
            label: i18n.t(
              'sales_portal.create_order_guide.upload_photo_or_file',
            ),
            onPress: onSelectUploadPhotoOrFile,
          },
        ]
      : []),
  ];

  const handleOptionPress = (onPress: () => void) => {
    close();
    onPress();
  };

  return (
    <DropdownMenu.Content width={DROPDOWN_WIDTH}>
      {options.map(({ description, Icon, label, onPress }) => {
        return (
          <DropdownMenu.Item
            height="auto"
            key={label}
            onPress={() => handleOptionPress(onPress)}
            paddingVertical="$8"
          >
            <XStack alignItems="flex-start" flex={1} gap="$8">
              <YStack height={optionTitleLineHeight} justifyContent="center">
                <Icon
                  color={theme.sk.color.icon.secondary}
                  size={OPTION_ICON_SIZE}
                />
              </YStack>
              <YStack alignItems="flex-start" flex={1}>
                <Typography
                  color={theme.sk.color.text.primary}
                  fontWeight="$medium"
                  size="$sm"
                >
                  {label}
                </Typography>
                <Typography color={theme.sk.color.text.tertiary} size="$xs">
                  {description}
                </Typography>
              </YStack>
            </XStack>
          </DropdownMenu.Item>
        );
      })}
    </DropdownMenu.Content>
  );
};
